import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import NavSidebar from './NavSidebar';
import { navResponsive } from '../navActions';

class Main extends Component {
    constructor() {
        super();
        this._onResponsive = this._onResponsive.bind(this);
    }

    _onResponsive(responsive) {
        this.props.dispatch(navResponsive(responsive));
    }

    render() {
        const {
            serverState,
            children,
        } = this.props;

        return (
            <div>
                <div>
                    <div style={{ height: 'max-content', display: 'flex' }}>
                        <div style={{ display: 'flex' }}>
                            <NavSidebar />
                        </div>
                        <div style={{ display: 'flex' }}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Main.propTypes = {
    children: PropTypes.any.isRequired,
    dispatch: PropTypes.func.isRequired,
    serverState: PropTypes.object,
    nav: PropTypes.shape({
        active: PropTypes.bool,
        enabled: PropTypes.bool,
        responsive: PropTypes.string
    })
};

const select = state => ({ serverState: state.session.serverState, nav: state.nav });

export default connect(select)(Main);
